import { RawDataResponse } from "../hooks/useRaw";

const paramsOrder = [
  "Particulate",
  "SO2",
  "NOx",
  "O2",
  "Opacity",
  "CO",
  "CO2",
  "Flow",
  "Velocity",
  "Pressure",
  "Temperature",
].reverse();
export const CORRECTED = ["Particulate", "Hg", "SO2", "NOx"];

const distinctSensor = (data: RawDataResponse, area?: string) =>
  data
    ?.map((company) =>
      company.mils
        ?.map((mils) =>
          mils.cems
            ?.filter((val) => (area ? val.area === area : !!val.uuid))
            ?.map((cem) => cem.parameters)
            ?.reduce((a, b) => a.concat(b), [])
        )
        ?.reduce((a, b) => a.concat(b), [])
    )
    ?.reduce((a, b) => a.concat(b), [])
    ?.filter((value, index, self) => {
      return self.map(({ name }) => name).indexOf(value.name) === index;
    })

    .sort((a, b) => a.name.localeCompare(b.name))
    .sort((a, b) => paramsSort(a.name, b.name));

export const paramsSort = (a: string, b: string) => paramsOrder.indexOf(b) - paramsOrder.indexOf(a);

export default distinctSensor;
